/*
 * The name a greeting uses (D-10 P11): the first word of the display name, because "Good morning,
 * Anna Beispiel." is a form letter and "Good morning, Anna." is a greeting. A display name that is
 * one word — an account made on the command line is greeted as its handle — is used whole.
 */

export function firstName(displayName: string): string {
	return displayName.trim().split(/\s+/)[0] ?? ""
}
